import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleAsset = () => {
  const { assetId } = useParams();
  const decodedId = assetId ? atob(assetId) : assetId;
  const id = decodedId.replace(/\D/g, ''); // Ensure we only get the numeric part
  const [assetDetails, setAssetDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchAssetDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.asset}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);

        // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'updated_at'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setAssetDetails(response.data);
      } catch (error) {
        console.error('Error fetching asset details:', error);
      }
    };

    fetchAssetDetails();
  }, [assetId]);

  return (
    <div>
      {assetDetails ? (
        <SingleItemDetailTemplate details={assetDetails} columns={columns} />
      ) : (
        <p>Loading asset details...</p>
      )}
    </div>
  );
};

export default SingleAsset;